import { render, staticRenderFns } from "./InitalView.vue?vue&type=template&id=e022f556&scoped=true"
import script from "./InitalView.vue?vue&type=script&lang=js"
export * from "./InitalView.vue?vue&type=script&lang=js"
import style0 from "./InitalView.vue?vue&type=style&index=0&id=e022f556&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e022f556",
  null
  
)

export default component.exports